export default "__VITE_ASSET__BhH_FaOE__"